<ng-container *ngIf="loading; else content">
  <app-loading text="Cargando detalles"></app-loading>
</ng-container>
<ng-template #content>
  <div
    *ngIf="!loading"
    class="flex flex-col md:flex-row md:justify-between gap-6 mb-6"
  >
    <div class="flex-1 flex flex-col space-y-2">
      <div class="flex items-center gap-4 sm:gap-6 mb-3 sm:mb-5">
        <app-nav-button [route]="routeNav"></app-nav-button>
        <span class="text-xs sm:text-sm text-gray-600">
          Título del puesto: {{ jobOffer.jobTitle.name }}
        </span>
      </div>
      <div *ngIf="!editModal" class="relative flex flex-col">
        <div class="flex items-start">
          <div class="flex flex-col">
            <h2
              class="text-lg sm:text-2xl font-bold text-gray-800 wrap-break-word leading-snug wrap-flex-grow min-w-0 pr-3"
            >
              {{ jobOffer.title }}
            </h2>
            <span class="text-sm sm:text-base text-gray-600 wrap-break-words">
              {{ jobOffer.subTitle }}
            </span>
          </div>
          <button
            *ngIf="jobOffer.publicationStatus === 'Publicado'"
            (click)="enableEdit()"
            class="bg-primary cursor-pointer text-white ml-3 sm:ml-5 rounded-full h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center shadow-md hover:scale-105 transition-transform shrink-0"
          >
            <div
              class="sm:w-[18px] sm:h-[18px] flex items-center justify-center"
            >
              <ng-icon name="heroPencil" size="16"></ng-icon>
            </div>
          </button>
        </div>
      </div>
      <div
        class="text-xs sm:text-sm text-gray-400 mt-1 flex flex-wrap gap-2 sm:gap-4"
      >
        <span>
          Oferta publicada:
          {{ jobOffer.publicationDate | date : "dd/MM/yyyy" }}</span
        >
      </div>
      <div class="mt-2">
        <ng-container
          *ngIf="jobOffer.publicationStatus === 'Publicado'; else finalized"
        >
          <button
            (click)="openCloseOfferConfirm()"
            class="h-9 sm:h-10 w-44 sm:w-48 text-primary text-xs sm:text-sm border border-primary rounded-md hover:bg-primary hover:text-white transition"
          >
            Cerrar oferta
          </button>
        </ng-container>
        <ng-template #finalized>
          <div
            class="h-9 sm:h-10 w-56 sm:w-64 flex text-xs sm:text-sm items-center justify-center text-red-500 px-3 sm:px-4 rounded border border-red-500 font-bold"
          >
            Oferta finalizada
          </div>
        </ng-template>
      </div>
    </div>
    <div
      class="bg-gray-100 flex items-start justify-center rounded-lg p-3 md:p-6 gap-3 sm:gap-4 flex-col md:w-1/3 lg:w-auto"
    >
      <div class="flex items-center gap-2">
        <ng-icon
          name="ionBriefcaseOutline"
          class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500"
        ></ng-icon>
        <span class="text-xs sm:text-sm font-medium"
          >Tipo de trabajo:
          <span class="font-normal">{{ jobOffer.type }}</span>
        </span>
      </div>
      <div class="flex items-center gap-2">
        <ng-icon
          name="ionPeopleOutline"
          class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500"
        ></ng-icon>
        <span class="text-xs sm:text-sm font-medium"
          >Vacantes:
          <span class="font-normal">{{ jobOffer.numberVacancies }}</span>
        </span>
      </div>
      <div class="flex items-center gap-2">
        <ng-icon
          name="ionTimerOutline"
          class="w-4 h-4 sm:w-5 sm:h-5 text-gray-500"
        ></ng-icon>
        <span class="text-xs sm:text-sm font-medium"
          >Experiencia mínima:
          <span class="font-normal">{{ jobOffer.minimumExperience }} años</span>
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="!loading" class="grid grid-cols-2 lg:grid-cols-4 gap-6 pt-5 mb-5">
    <div
      class="rounded-md text-primary p-4 sm:p-6 border border-gray-200 text-center"
    >
      <ng-icon
        name="heroChartPie"
        class="w-10 h-10 sm:w-12 sm:h-12 mx-auto"
      ></ng-icon>
      <h2 class="font-medium mb-1 text-base sm:text-lg">
        Distribución de Género
      </h2>
      <div class="mt-2 text-gray-900">
        @if(stats){
        <p class="text-sm sm:text-xl font-medium">
          {{ stats.malePercentage | cleanPercent }} Hombres
        </p>
        <p class="text-sm sm:text-xl font-medium">
          {{ stats.femalePercentage | cleanPercent }} Mujeres
        </p>
        } @else {
        <p class="text-sm sm:text-lg font-medium text-gray-500">
          Sin estadísticas
        </p>
        }
      </div>
    </div>
    <div
      class="rounded-md p-4 sm:p-6 border border-gray-200 text-center text-primary"
    >
      <ng-icon
        name="heroBriefcase"
        class="w-10 h-10 sm:w-12 sm:h-12 mx-auto"
      ></ng-icon>
      <h2 class="font-medium mb-1 text-base sm:text-lg">Total Postulantes</h2>
      @if(stats){
      <p class="text-xl sm:text-3xl text-gray-900 mt-4 sm:mt-6 font-medium">
        {{ stats.numJobOfferPostulant }}
      </p>
      } @else {
      <p class="text-xl sm:text-3xl text-gray-500 mt-4 sm:mt-6 font-medium">
        0
      </p>
      }
    </div>
    <div
      class="rounded-md p-4 sm:p-6 border border-gray-200 text-center text-primary"
    >
      <ng-icon
        name="heroEye"
        class="w-10 h-10 sm:w-12 sm:h-12 mx-auto"
      ></ng-icon>
      <h2 class="font-medium mb-1 text-base sm:text-lg">Visitas</h2>
      @if(stats){
      <p class="text-xl sm:text-3xl text-gray-900 mt-4 sm:mt-6 font-medium">
        {{ stats.visitsNumber }}
      </p>
      } @else {
      <p class="text-2xl sm:text-3xl text-gray-500 mt-4 sm:mt-6 font-medium">
        0
      </p>
      }
    </div>
    <div
      class="rounded-md p-4 sm:p-6 border border-gray-200 text-center text-primary"
    >
      <ng-icon
        name="heroCalendar"
        class="w-10 h-10 sm:w-12 sm:h-12 mx-auto"
      ></ng-icon>
      <h2 class="font-medium mb-1 text-base sm:text-lg">Último Postulante</h2>
      @if(stats){
      <p class="text-sm sm:text-lg text-gray-900 mt-4 sm:mt-6 font-medium">
        {{ stats.dateLastPostulant | relativeDate }}
      </p>
      } @else {
      <p class="text-sm sm:text-lg text-gray-500 mt-4 sm:mt-6 font-medium">
        Sin postulantes
      </p>
      }
    </div>
  </div>
  <div
    *ngIf="postulants.length > 0 && !loading; else noApplicants"
    class="overflow-x-auto"
  >
    <table class="min-w-full table-auto text-sm text-left">
      <thead class="text-gray-700 border-b border-gray-200">
        <tr>
          <th class="py-2 px-4">Nombre completo</th>
          <th class="py-2 px-4 hidden md:table-cell">Estado</th>
          <th class="py-2 px-4 text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let user of postulants"
          class="border-b border-gray-200 hover:bg-indigo-50/20 transition"
        >
          <td class="py-3 px-4 flex items-center min-w-0">
            <img
              [src]="user.image || 'assets/img/user2.jpg'"
              alt="Foto de perfil"
              class="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover border border-gray-300 mr-3 md:mr-5 shrink-0"
            />
            <span class="truncate">
              {{ user.user.firstName }} {{ user.user.lastName }}
            </span>
          </td>
          <td class="py-3 px-4 hidden md:table-cell">
            <span
              class="px-2 py-1 rounded-full text-white text-xs font-semibold whitespace-nowrap"
              [ngClass]="{
                'bg-gray-400': user.statusProcess === 'Enviado',
                'bg-blue-500': user.statusProcess === 'Revisado',
                'bg-yellow-500': user.statusProcess === 'Preseleccionado',
                'bg-green-500': user.statusProcess === 'Seleccionado'
              }"
            >
              {{ getStatusLabel(user) }}
            </span>
          </td>
          <td class="py-3 px-4 text-right">
            <div class="flex justify-end items-center space-x-2">
              <div class="md:hidden shrink-0">
                <span
                  class="inline-block w-2.5 h-2.5 rounded-full"
                  [ngClass]="{
                    'bg-gray-400': user.statusProcess === 'Enviado',
                    'bg-blue-500': user.statusProcess === 'Revisado',
                    'bg-yellow-500': user.statusProcess === 'Preseleccionado',
                    'bg-green-500': user.statusProcess === 'Seleccionado'
                  }"
                  title="{{ getStatusLabel(user) }}"
                ></span>
              </div>
              <button
                *ngIf="user.statusProcess !== 'Revisado'"
                (click)="
                  openConfirmModal('retroceder', user.idJobOfferPostulant)
                "
                class="px-2 py-1 cursor-pointer border text-xs rounded-md transition bg-gray-100 text-gray-700 hover:bg-gray-200 hidden sm:block"
              >
                Retroceder
              </button>
              <button
                (click)="
                  openConfirmModal(
                    getNextAction(user),
                    user.idJobOfferPostulant
                  )
                "
                [disabled]="user.statusProcess === 'Seleccionado'"
                class="px-2 py-1 border text-xs rounded-md transition cursor-pointer"
                [ngClass]="{
                  'border-primary text-primary hover:bg-primary hover:text-white':
                    user.statusProcess !== 'Seleccionado',
                  'border-gray-400 text-gray-400 bg-gray-100 cursor-not-allowed':
                    user.statusProcess === 'Seleccionado'
                }"
              >
                <span class="hidden sm:inline">{{
                  getNextActionLabel(user)
                }}</span>
                <div class="sm:hidden flex items-center justify-center">
                  <ng-icon name="heroArrowPath" size="14"></ng-icon>
                </div>
              </button>
              <button
                (click)="viewUserProfile(user.idJobOfferPostulant)"
                class="px-2 py-1 cursor-pointer border border-gray-400 text-gray-700 text-xs rounded-md hover:bg-gray-200 transition"
              >
                <span class="hidden sm:inline">Ver perfil</span>
                <div class="sm:hidden flex justify-center items-center">
                  <ng-icon name="heroUser" size="14"></ng-icon>
                </div>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noApplicants>
    <div class="text-center text-gray-500 py-10 h-96">
      <p class="text-lg">Aún no hay postulantes para esta oferta.</p>
      <p class="text-sm mt-2">Cuando alguien postule, aparecerá aquí.</p>
    </div>
  </ng-template>
</ng-template>
<div
  *ngIf="confirmModalOpen"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4" *ngIf="actionType">
      ¿Estás seguro que deseas {{ actionMessage }}?
    </h2>

    <div class="flex justify-center gap-4">
      <button
        (click)="closeConfirmModal()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        (click)="confirmAction()"
        [text]="'Confirmar'"
        [loading]="isLoadingStatusProcess"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
<div
  *ngIf="closeOfferModalOpen"
  class="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas cerrar esta oferta de trabajo?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeCloseOfferModal()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        (click)="confirmCloseOffer()"
        [text]="'Cerrar oferta'"
        [loading]="loadingSubmit"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
<app-job-offer-update
  *ngIf="editModal"
  [jobOffer]="jobOffer"
  [loading]="loadingUpdate"
  (update)="updateJobOffer($event)"
  (close)="editModal = false"
>
</app-job-offer-update>
